import classNames from 'classnames';
import { ForwardedRef } from 'react';

import CloseIcon from '../icons/CloseIcon';
import BasicButton, { BasicButtonElement, BasicButtonProps } from './BasicButton';

import styles from '../../styles/buttons/menu-button.module.css';

function CloseButton({
    className = null,
    ref: buttonRef = null,
    ...props
}: BasicButtonProps & { ref?: ForwardedRef<BasicButtonElement> | null }) {
    return (
        <BasicButton
            className={classNames([styles.container, className])}
            ref={buttonRef}
            {...props}
        >
            <CloseIcon className={styles.icon} />
        </BasicButton>
    );
}

export default CloseButton;
